<template>
  <div
    class="page_middle_container projectExecute_container"
    v-loading.fullscreen.lock="loadingData"
  >
    <div class="page_middle_title">
      需求发送
      <i
        class="el-icon-close page_middle_close"
        @click="doClose"
        v-if="query.id == undefined"
      ></i>
    </div>
    <div class="page_middle_content">
      <div class="project_execute_page_middle_row">
        <div class="project_execute_middle_row_block">
          <div class="projectExecuteComponents_page_middle_row_key">
            <span class="page_middle_row_key_required">*</span>项目号：
          </div>
          <div class="page_middle_row_value">
            <el-input
              disabled
              v-model.trim="data.project_number"
              placeholder="请输入项目号"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="project_execute_page_middle_row">
        <div class="project_execute_middle_row_block">
          <div class="projectExecuteComponents_page_middle_row_key">
            需求名称：
          </div>
          <div class="page_middle_row_value">
            <el-input
              :disabled="true"
              v-model.trim="data.demand_name"
              placeholder="请输入需求名称"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="project_execute_page_middle_row">
        <div class="project_execute_middle_row_block">
          <div
            class="projectExecuteComponents_page_middle_row_key"
            style="text-align: right"
          >
            需求编号：
          </div>
          <div class="page_middle_row_value">
            <el-input
              :disabled="true"
              v-model.trim="data.demand_number"
              placeholder="保存或发送后自动生成"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="project_execute_page_middle_row">
        <div class="project_execute_middle_row_block">
          <div class="projectExecuteComponents_page_middle_row_key">
            <span class="column_radio_group page_middle_row_key_required">*</span>需求类型：
          </div>
          <div class="page_middle_row_value">
              <el-select :disabled="true" v-model="data.task_type" placeholder="需求类型">
                <el-option v-for="(item, index) in config.projectType" :key="index" :value="item.index" :label="item.label"></el-option>
              </el-select>
            <!-- <el-radio-group :disabled="true" v-model="data.task_type">
              <el-radio
                v-for="(item, index) in config.projectType"
                :key="index"
                :label="index"
                size="small"
              >
                {{ item }}</el-radio
              >
            </el-radio-group> -->
          </div>
        </div>
      </div>
      <!-- <platformSynthesis :isWatch="isWatch"></platformSynthesis> -->
      <component
        v-if="components"
        v-bind:is="components"
        ref="project_execute_components"
        :isWatch="true"
        :subTaskData="subTaskData"
        :project_id="data.project_id"
        :noSendtaskType="cacheTaskType"
        @setAttachmentFile="setAttachmentFile"
      ></component>
      <div class="project_execute_page_middle_row">
        <div
          class="project_execute_middle_row_block"
          style="align-items: flex-start"
        >
          <div class="projectExecuteComponents_page_middle_row_key">
            <span class="column_radio_group page_middle_row_key_required">*</span>需求说明：
          </div>
          <div class="page_middle_row_value">
            <div style="border: 1px solid #ccc;word-break: break-all;width: 100%;">
              <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editor['requirement']"
                :defaultConfig="toolbarConfig"
                :mode="mode"
              />
              <Editor
                style="height: 300px; overflow-y: hidden"
                v-model="data.requirement"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onCreated="
                  (editor) => {
                    onCreated(editor, 'requirement');
                  }
                "
              />
            </div>
            <!-- <el-input
                        :disabled="isWatch"
                        type="textarea"
                        v-model="data.requirement"
                        rows="4"
                        placeholder="请输入需求补充说明"
                    ></el-input> -->
          </div>
        </div>
      </div>
      <div class="project_execute_page_middle_row">
        <div
          class="project_execute_middle_row_block"
        >
          <div
            class="projectExecuteComponents_page_middle_row_key"
          >
            附件：
          </div>
          <div class="page_middle_row_value" style="padding-left: 15px;">
            <div v-if="data.requirement_attachment">
              <div  style="margin-bottom: 5px;"
                v-for="(item, index) in data.requirement_attachment.split(',')"
                :key="index"
              >
                <span class="global_link" @click="openLink(item)">
                  {{ $tools.getFileNameFromURL(item) }}
                </span>
              </div>
            </div>
            <div v-else>无</div>
          </div>
        </div>
      </div>
      <div
        class="page_middle_body"
        v-if="data.po_examine_status == 0 && !query.isWatch"
        style="margin-top: 10px"
      >
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="projectExecuteComponents_page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>审批结果：
            </div>
            <div class="page_middle_row_value">
              <el-select
                v-model="auditData.po_examine_status"
                placeholder="请选择审批结果"
              >
                <el-option :value="1" label="通过"></el-option>
                <el-option :value="2" label="驳回"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="projectExecuteComponents_page_middle_row_key">
              <span class="page_middle_row_key_required" v-if="auditData.po_examine_status == 2">*</span>审批备注：
            </div>
            <div class="page_middle_row_value">
              <el-input
                v-model.trim="auditData.po_examine_reason"
                placeholder="请输入审批备注"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_buttongroup">
          <el-button type="primary" @click="doCommit" :loading="loading" style="width: 16vw;" size="small"
            >审核</el-button
          >
        </div>
      </div>
      <div class="page_middle_body" v-else style="margin-top: 10px">
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="projectExecuteComponents_page_middle_row_key">
              审批结果：
            </div>
            <div class="page_middle_row_value" style="display: flex;align-items: center;">
              <el-icon style="font-size: 4vw;color: #67c23a;margin-right: 5px;" v-if="data.po_examine_status == 1"><SuccessFilled /></el-icon>
              <el-icon style="font-size: 4vw;color: red;margin-right: 5px;" v-if="data.po_examine_status == 2"><CircleCloseFilled /></el-icon>
              <span>
                {{ $config.types.auditResult[data.po_examine_status] }}
              </span>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="projectExecuteComponents_page_middle_row_key">
              审批备注：
            </div>
            <div class="page_middle_row_value">
              {{ data.po_examine_reason }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
//平台综合类
import platformSynthesis from "@/components/page/project/projectExecuteComponents/platformSynthesis";
import medicalMaterials from "@/components/page/project/projectExecuteComponents/medicalMaterials";
import visualizationTask from "@/components/page/project/projectExecuteComponents/visualizationTask";
import projectExecuteTask from "@/components/page/project/projectExecuteComponents/projectExecuteTask";
import { SuccessFilled, CircleCloseFilled } from "@element-plus/icons";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
export default {
  name: "page_middle",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    components() {
      // return "platformSynthesis"
      return this.$tools.isNewProjectExe(this.created_time)?"platformSynthesis":this.config.projectComponent[this.data.task_type];
    },
  },
  components: {
    Editor,
    Toolbar,
    platformSynthesis,
    medicalMaterials,
    visualizationTask,
    projectExecuteTask,
    SuccessFilled, 
    CircleCloseFilled 
  },
  data() {
    return {
      data: {
        project_id: "",
        project_number: "",
        demand_name: "",
        demand_number: "",
        task_type: 0,
        requirement: "",
        requirement_attachment: "",
        is_send: 0,
      },
      config: {
        projectComponent: [
          "platformSynthesis",
          "medicalMaterials",
          "visualizationTask",
          "projectExecuteTask",
          "platformSynthesis",
          "platformSynthesis"
        ],
        newProjectComponent: [
          "platformSynthesis",
          "platformSynthesis",
          "platformSynthesis",
          "platformSynthesis",
          "platformSynthesis",
          "platformSynthesis"
        ],
        projectType: this.$config.types.newProjectDemandType,
        isRequired: {
          isRequired: false,
          title: "",
        },
      },
      toolbarConfig: this.$config.toolbarConfig,
      mode: "default", // or 'simple'
      editorConfig: { placeholder: "请输入内容..." },
      editor: {
        requirement: null,
      },
      created_time:"",
      cacheTaskType: -1,
      subTaskData: {},
      isWatch: false,
      loading: false,
      loadingData: false,
      auditData: {
        id: "",
        po_examine_status: "",
        po_examine_reason: "",
        operation_url: window.location.href,
      },
    };
  },
  created() {
    this.query = { ...this.$route.query };
    this.isWatch = !!this.query.id || !!this.item.isWatch;
    this.initData(this.query.id);
  },
  mounted() {},
  methods: {
    initData(id) {
      if (this.isWatch) {
        this.loadData(id);
        return;
      }
    },

    loadData(id) {
      this.loadingData = true;
      let url = this.$tools.getURL(this.$urls.taskProject.detail, { id: id });
      this.$axios
        .get(url)
        .then((res) => {
          this.loadingData = false;
          this.data = res.data;
          this.created_time = res.data.created_time?new Date(res.data.created_time).getTime():new Date().getTime();
          if(this.$tools.isNewProjectExe2(this.created_time)){
            this.config.projectType = this.$config.types.newProjectDemandType;
          }else{
              this.config.projectType = this.$config.types.projectDemandType;
          }
          this.subTaskData = res.data.sub_task;
          this.auditData.id = res.data.id;
        })
        .catch((err) => {
          this.loadingData = false;
          console.log(err);
        });
    },

    setAttachmentFile(files) {
      this.requirement_attachment = files ? files.split(",") : [];
      this.data.requirement_attachment = this.requirement_attachment.join(",");
    },
    openLink(url) {
      this.$tools.downLoadFile(url);
    },
    doClose() {
      this.$emit("doClose");
    },
    onCreated(editor, key) {
      this.editor[key] = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      this.editor[key].disable();
      // if (this.isWatch) {
      //   this.editor[key].disable();
      // }
    },
    verifyData() {
      if (!this.auditData.po_examine_status) {
        this.$tips.error({ text: "请选择审批结果" });
        return false;
      }
      if (
        this.auditData.po_examine_status == 2 &&
        !this.auditData.po_examine_reason
      ) {
        this.$tips.error({ text: "请输入审批备注" });
        return false;
      }
      return true;
    },
    doCommit() {
      if (this.loading || !this.verifyData()) {
        return;
      }
      this.loading = true;
      let url = this.$urls.projectList.taskAudit;
      this.$axios
        .post(url, this.auditData)
        .then(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          this.$tips.success({ text: "审核完成" });

          this.initData(this.query.id);
        })
        .catch(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
  },
};
</script>
<style>
.page_middle_detail .page_middle_field_name {
  /* width:60px; */
}
.projectExecute_container .el-textarea,
.projectExecute_container .el-input,
.projectExecute_container .el-select {
  /* width: 500px; */
  width: 100%;
}
.project_execute_middle_row_block {
  display: flex;
  align-items: center;
  /* width: 100%; */
  flex: 1 0 0;
  min-height: 40px;
}
.page_middle_row_attachment_key {
  flex: 120px 0 0;
  text-align: right;
  margin-right: 20px;
}
.project_execute_page_middle_row {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
</style>